import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import externalUserModal from "./modules/externalUserModal";
import { putAction, getAction } from '@/api/manage';
import { editExtralUser, userDefaultPassword } from '@/api/api';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
export default {
  name: 'UserList',
  mixins: [JeecgListMixin],
  components: {
    externalUserModal: externalUserModal
  },
  data: function data() {
    return {
      description: '这是用户管理页面',
      queryParam: {},
      columns: [{
        title: '编号',
        align: 'center',
        dataIndex: 'code',
        width: 120
      }, {
        title: '名称',
        align: 'center',
        dataIndex: 'name',
        width: 120
      }, {
        title: '开始时间',
        align: 'center',
        dataIndex: 'stime',
        width: 120
      }, {
        title: '结束时间',
        align: 'center',
        dataIndex: 'etime',
        width: 120
      }, {
        title: '状态',
        align: 'center',
        width: 80,
        dataIndex: 'status_dictText'
      }, {
        title: '操作',
        dataIndex: 'action',
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 170
      }],
      url: {
        imgerver: window._CONFIG['domianURL'] + '/sys/common/view',
        syncUser: '/process/extActProcess/doSyncUser',
        list: '/sys/open/user',
        delete: '/sys/open/user',
        deleteBatch: '/sys/open/user',
        exportXlsUrl: '/sys/open/user/exportXls',
        importExcelUrl: 'sys/open/user/importExcel',
        resetPassword: 'sys/open/user/resetPassword'
      }
    };
  },
  computed: {
    importExcelUrl: function importExcelUrl() {
      return "".concat(window._CONFIG['domianURL'], "/").concat(this.url.importExcelUrl);
    }
  },
  methods: {
    loadData: function loadData(arg) {
      this.queryParam.delFlag = 0;
      this.initTableData(arg);
    },
    getAvatarView: function getAvatarView(avatar) {
      return this.url.imgerver + '/' + avatar;
    },
    batchFrozen: function batchFrozen(status) {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return false;
      } else {
        var ids = '';
        var that = this;
        that.selectedRowKeys.forEach(function (val) {
          ids += val + ',';
        });
        that.$confirm({
          title: '确认操作',
          content: '是否' + (status == 1 ? '解冻' : '冻结') + '选中账号?',
          onOk: function onOk() {
            editExtralUser({
              ids: ids,
              status: status
            }).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: res.message
                });
                that.loadData();
                that.onClearSelected();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        });
      }
    },
    handleMenuClick: function handleMenuClick(e) {
      if (e.key == 1) {
        this.batchDel();
      } else if (e.key == 2) {
        this.batchFrozen(2);
      } else if (e.key == 3) {
        this.batchFrozen(1);
      } else if (e.key == 4) {
        this.resetPassword();
      }
    },
    handleFrozen: function handleFrozen(record, status) {
      console.log('record', record);
      var id = record.id;
      record.status = status;
      var that = this;
      editExtralUser(record).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loadData();
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    },
    handleChangePassword: function handleChangePassword(username) {
      this.$refs.passwordmodal.show(username);
    },
    passwordModalOk: function passwordModalOk() {//TODO 密码修改完成 不需要刷新页面，可以把datasource中的数据更新一下
    },
    resetPassword: function resetPassword() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return false;
      } else {
        var ids = '';
        var that = this;
        that.selectedRowKeys.forEach(function (val) {
          ids += val + ',';
        });
        getAction(this.url.resetPassword, {
          ids: ids
        }).then(function (res) {
          if (res) {
            that.$notification.success({
              message: '修改成功!'
            });
            that.loadData();
          } else {
            that.$notification.warning({
              message: '修改失败!'
            });
          }
        });
      }
    }
  }
};